module.exports = __webpack_public_path__ + "img/pc_user_bg_top.5bbfc667.png";